import React, { Component } from "react";

import {
  CButton,
  CDropdown,
  CDropdownToggle,
  CDropdownMenu,
  CDropdownItem,
  CModal,
  CModalFooter,
  CModalBody,
  CModalHeader,
  CModalTitle
} from "@coreui/react";
import { BootstrapTable, TableHeaderColumn } from "react-bootstrap-table";
import { connect } from "react-redux";
import { toastr } from "react-redux-toastr";
import { bindActionCreators } from "redux";

import URL from "../../config/api";
import axios from "../../config/axios";
import Loading from "../Loading";

import "react-bootstrap-table/dist//react-bootstrap-table-all.min.css";

class SelectModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: true,
      activities: [],
      docs: [],
      selected: null,
      doc_id: null,
      type: this.props.isRoom ? "doc" : "activity"
    };

    this.selectRowProp = {
      mode: "radio",
      bgColor: "#3399ff22", // you should give a bgcolor, otherwise, you can't regonize which row has been selected
      hideSelectColumn: true, // enable hide selection column.
      clickToSelect: true // you should enable clickToSelect, otherwise, you can't select column.
    };

    this.options = {
      onRowClick: row => this.onRowClick(row),
      onRowDoubleClick: row => this.onRowDoubleClick(row)
    };
  }

  onRowClick(row) {
    if (row.back === true) {
      this.setState({ selected: null });
    } else if (this.state.selected && row.id === this.state.selected.id) {
      this.setState({ selected: null });
    } else {
      this.setState({ selected: row });
    }
  }

  onRowDoubleClick(row) {
    if (row.folder) {
      this.setState({ doc_id: row.id });
    }
  }

  error(response) {
    if (response === "Unauthorized") {
      this.props.logout(this.props.user.token);
    } else {
      toastr.error("Falha", response);
    }
  }

  componentDidMount() {
    if (this.state.type === "activity") {
      this.setActivity();
    } else {
      this.setDoc();
    }
  }

  setActivity() {
    this.setState({ type: "activity", loading: true, selected: null });

    const id = this.props.room;

    axios
      .post(
        `${URL.api}activity/activity/filter`,
        { user: this.props.user.user.id, room: id },
        { headers: { Authorization: `Bearer ${this.props.user.token}` } }
      )
      .then(
        resp => {
          this.setState({ activities: resp.data.data, loading: false });
        },
        error => {
          this.error(error.response.statusText);
        }
      );
  }

  setDoc() {
    this.setState({ type: "doc", loading: true, selected: null });

    const id = this.props.room;
    axios
      .post(
        `${URL.api}content/doc/listRoom`,
        { room_id: id, user_id: this.props.user.user.id },
        { headers: { Authorization: `Bearer ${this.props.user.token}` } }
      )
      .then(
        resp => {
          this.setState({ docs: resp.data.data, loading: false });
        },
        error => {
          this.error(error.response.statusText);
        }
      );
  }

  render() {
    let docs = [];
    if (this.state.doc_id) {
      docs.push({
        id: this.state.docs.find(item => item.id === this.state.doc_id).doc_id,
        name: "..",
        folder: true,
        back: true
      });
    }
    docs = docs.concat(
      this.state.docs.filter(item => item.doc_id === this.state.doc_id)
    );

    return (
      <CModal
        size="lg"
        show
        onClose={() => this.props.onClose()}
        closeOnBackdrop={false}
      >
        <CModalHeader closeButton>
          {this.props.isRoom ? (
            <CModalTitle className="d-inline-block mr-1">
              Documentos
            </CModalTitle>
          ) : (
            <CDropdown className="d-inline-block">
              <CDropdownToggle color="white" className="p-0">
                <CModalTitle className="d-inline-block mr-1">
                  {this.state.type === "activity" ? "Atividades" : "Documentos"}
                </CModalTitle>
              </CDropdownToggle>
              <CDropdownMenu
                placement="bottom"
                modifiers={[{ name: "flip", enabled: false }]}
              >
                <CDropdownItem onClick={() => this.setActivity()}>
                  Atividades
                </CDropdownItem>
                <CDropdownItem onClick={() => this.setDoc()}>
                  Documentos
                </CDropdownItem>
              </CDropdownMenu>
            </CDropdown>
          )}
        </CModalHeader>
        <CModalBody
          className="p-0"
          style={{ maxHeight: "600px", overflow: "auto" }}
        >
          {this.state.loading ? (
            <div className="d-flex p-3 justify-content-center">
              <Loading />
            </div>
          ) : this.state.type === "activity" ? (
            this.state.activities.length > 0 ? (
              <BootstrapTable
                data={this.state.activities}
                selectRow={this.selectRowProp}
                options={this.options}
                tableStyle={{ border: 0 }}
                trClassName="cursor"
                hover
                version="4"
              >
                <TableHeaderColumn
                  isKey
                  className="d-none"
                  tdStyle={{ width: "1rem", border: 0, padding: "1.25rem" }}
                  dataField="id"
                  dataFormat={() => (
                    <i className="fa fa-line-chart text-primary"></i>
                  )}
                >
                  Id
                </TableHeaderColumn>
                <TableHeaderColumn
                  className="d-none"
                  tdStyle={{ border: 0, padding: "1.25rem" }}
                  dataField="name"
                >
                  Nome
                </TableHeaderColumn>
              </BootstrapTable>
            ) : (
              <div className="d-flex p-3 justify-content-center">
                <span className="text-center text-muted">
                  Nenhuma atividade encontrada
                </span>
              </div>
            )
          ) : docs.length > 0 ? (
            <BootstrapTable
              data={docs}
              selectRow={this.selectRowProp}
              options={this.options}
              tableStyle={{ border: 0 }}
              trClassName="cursor"
              hover
              version="4"
            >
              <TableHeaderColumn
                isKey
                className="d-none"
                tdStyle={{ width: "1rem", border: 0, padding: "1.25rem" }}
                dataField="id"
                dataFormat={id => {
                  const doc = docs.find(item => item.id === id);
                  return (
                    <i
                      className={
                        doc.back
                          ? "fa fa-folder-open text-muted"
                          : doc.folder
                          ? "fa fa-folder text-muted"
                          : "fa fa-file text-warning"
                      }
                    ></i>
                  );
                }}
              >
                Id
              </TableHeaderColumn>
              <TableHeaderColumn
                className="d-none"
                tdStyle={{ border: 0, padding: "1.25rem" }}
                dataField="name"
              >
                Nome
              </TableHeaderColumn>
            </BootstrapTable>
          ) : (
            <div className="d-flex p-3 justify-content-center">
              <span className="text-center text-muted">
                Nenhum documento encontrado
              </span>
            </div>
          )}
        </CModalBody>
        <CModalFooter>
          <CButton
            color="primary"
            disabled={this.state.selected === null}
            onClick={() =>
              this.props.onClose(this.state.selected, this.state.type)
            }
          >
            Selecionar
          </CButton>{" "}
          <CButton color="secondary" onClick={() => this.props.onClose()}>
            Cancelar
          </CButton>
        </CModalFooter>
      </CModal>
    );
  }
}

const mapStateToProps = state => ({
  user: state.user,
  general: state.general,
  profile: state.profile,
  form: state.form
});

function mapDispatchToProps(dispatch) {
  return bindActionCreators({}, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(SelectModal);
